import { AxiosPromise } from "axios"
import { PracticeFunction } from "app/models/practice"
import { planningApi } from "./api"

export const getFunctions = (): AxiosPromise => planningApi("/functions")

export const patchFunctions = (functionUpdate: PracticeFunction): AxiosPromise =>
  planningApi(`/functions/${functionUpdate.id}`, {
    data: functionUpdate,
    method: "PATCH",
  })

export const patchFunctionsOrder = (orderedIds: string[]): AxiosPromise =>
  planningApi("/functions_order", {
    method: "PATCH",
    data: { orderedIds },
  })

export const postFunction = (newFunction: Pick<PracticeFunction, "name">): AxiosPromise =>
  planningApi("/functions", {
    data: newFunction,
    method: "POST",
  })
